import React, { useState } from "react";
// Removed: import { Container, Row, Col, Form, InputGroup } from "react-bootstrap";
// Note: Assuming 'react-bootstrap' components are available globally or managed by the surrounding environment.
import { Container, Row, Col, Form, InputGroup } from "react-bootstrap";
import axios from "axios";
import { Mail, Send, CheckCircle } from "lucide-react";

// Use environment variables defined in the login component context
const API_URL = process.env.REACT_APP_API_URL;
// const DOMAIN_NAME = process.env.REACT_APP_DOMAIN_NAME; // No longer needed for display

export default function FindSubdomain() {

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  // State for flow: 1: Enter Email, 2: Success/Email Sent
  const [step, setStep] = useState(1); 
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState(""); 

  // --- Step 1: Send Subdomain Link to Email ---
  const handleSendLink = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccessMessage("");
    
    // Note: Re-using the previous verify-subdomain-otp endpoint for the new flow
    const endpoint = API_URL + "/api/auth/verify-subdomain-otp"; 

    const generateRandomBuster = (url) => {
      const separator = url.includes('?') ? '&' : '?';
      const added = `${separator}_=${Date.now()}`;
  
      return url + added;
    }
    try {
      const resp = await axios.post(generateRandomBuster(endpoint), { 
        email,
      });

      setStep(2); // Move to the success step
      
      setSuccessMessage(resp.data.message || "Your company's access link has been sent to your email. Please check your inbox.");

    } catch (err) {
      // Catch specific errors, but often a generic message is better for domain/email recovery
      const message = err.response?.data?.message || err.response?.data?.error || "Failed to send access link. Please verify your email or try again later.";
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  // --- Render Content Based on Step ---

  const renderContent = () => {
    switch (step) {
      case 1:
        return (
          <>
            <div className="img_cont">
              <h3>Find Your Company Domain</h3>
              <p>Enter the email address associated with your account, and we'll send your dedicated login link directly to you.</p>
            </div>
            <Form onSubmit={handleSendLink}>
              <Form.Group className="mb-4 subdomain_group" controlId="FindDomainEmail">
                <InputGroup>
                  <InputGroup.Text id="email-icon" className="form_icon">
                    <Mail />
                  </InputGroup.Text>
                  <Form.Control
                    type="email"
                    placeholder="name@example.com"
                    value={email}
                    onInput={(e) => setEmail(e.currentTarget.value)}
                    aria-describedby="email-icon"
                    disabled={loading}
                    required
                  />
                </InputGroup>
              </Form.Group>
              <div className="button_group">
                <button
                  disabled={loading || !email}
                  className="next_btn"
                  type="submit"
                >
                  <Send size={18} className="mr-2" style={{marginRight: '8px'}} />
                  {loading ? "Sending Link..." : "Send Login Link"}
                </button>
              </div>
            </Form>
          </>
        );

      case 2:
        return (
          <>
            <div className="img_cont">
              <h3>Link Sent!</h3>
              <CheckCircle size={48} className="text-green-600 mb-4" />
              <p className="text-lg font-semibold text-green-700">Check Your Inbox</p>
              <p className="text-gray-600">{successMessage}</p>
              <p style={{fontSize: '0.9em', color: '#666', marginTop: '10px'}}>
                This may take a moment. If you don't receive it, please check your spam folder.
              </p>
            </div>
            
            <div className="button_group">
              <button
                className="whats_domain"
                onClick={() => setStep(1)}
              >
                Send to a Different Email
              </button>
            </div>
          </>
        );

      default:
        return null;
    }
  };


  return (
    <>
      <style>{`
        .login_cont {
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 100vh;
          background-color: #f7f9fc;
          font-family: 'Inter', sans-serif;
        }
        .form_cont {
          width: 100%;
          margin: 20px;
        }
        .form_card {
          padding: 30px;
          background: #ffffff;
          border-radius: 12px;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
        }
        .img_cont {
          text-align: center;
          margin-bottom: 30px;
        }
        .img_cont img {
          margin-bottom: 10px;
        }
        .img_cont h3 {
          font-size: 1.5rem;
          color: #1e3a8a;
          font-weight: 700;
        }
        .img_cont p {
          color: #6b7280;
          font-size: 0.95rem;
          margin-top: 10px;
        }
        .form_icon {
          background-color: #eef2ff !important;
          border-right: none !important;
          color: #1e3a8a !important;
          border-top-left-radius: 8px !important;
          border-bottom-left-radius: 8px !important;
        }
        .form-control {
          border-left: none !important;
          border-top-right-radius: 8px !important;
          border-bottom-right-radius: 8px !important;
          height: 48px;
        }
        .form-control:focus {
          box-shadow: 0 0 0 0.25rem rgba(40, 60, 175, 0.25) !important;
          border-color: #4f46e5 !important;
        }
        .next_btn, .whats_domain {
          width: 100%;
          border-radius: 8px;
          padding: 12px;
          font-size: 1rem;
          font-weight: 600;
          transition: background-color 0.3s, transform 0.1s;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .next_btn {
          background-color: #1e3a8a;
          color: white;
          border: none;
          margin-bottom: 10px;
        }
        .next_btn:hover:not(:disabled) {
          background-color: #1d4ed8;
        }
        .next_btn:disabled {
          background-color: #93c5fd;
          cursor: not-allowed;
        }
        .whats_domain {
          background-color: transparent;
          color: #1e3a8a;
          border: 2px solid #1e3a8a;
        }
        .whats_domain:hover:not(:disabled) {
          background-color: #eff6ff;
        }
        .button_group {
          margin-top: 20px;
        }
        .additional_links {
          margin-top: 20px;
          text-align: center;
        }
        .links_cont a {
          color: #6b7280;
          text-decoration: none;
          font-size: 0.85rem;
        }
        .links_cont a:hover {
          color: #1e3a8a;
        }
      `}</style>
      <div className="login_cont">
        <div className="form_cont">
          <Container fluid className="form_card">
            <Row>
              <Col>
                <div className="img_cont">
                  <img src="/nest-logo.png" alt="logo" />
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                {/* Error message display */}
                {error && (
                  <p style={{ color: "red", textAlign: "center", marginBottom: "15px", fontWeight: "500" }}>{error}</p>
                )}
                
                {renderContent()}

                {/* Link back to login only if not on success page */}
                {step !== 2 && (
                  <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <a href="/login" style={{ color: '#1e3a8a', fontSize: '0.9em', textDecoration: 'none' }}>
                      &larr; Back to Login
                    </a>
                  </div>
                )}
              </Col>
            </Row>
          </Container>

          <Container fluid className="additional_links">
            <Row>
              <Col>
                <div className="links_cont">
                  <a href="/privacy">Privacy Policy</a>
                  <span style={{ paddingLeft: "1vh" }}>.</span>
                  <a href="/terms" style={{ paddingLeft: "1vh" }}>
                    Terms of Services
                  </a>
                  <span style={{ paddingLeft: "1vh" }}>.</span>
                  <a href="/" style={{ paddingLeft: "1vh" }}>
                    Register
                  </a>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}
